import { useState } from "react";
import { Truck } from "lucide-react";
import "./DriverPage.scss";
import DriverRoutesSection from "./sections/DriverRoutesSection";
import { useAuth } from "../../context/AuthContext";
import { SharedSidebar } from "../../components";

const DRIVER_MENU_ITEMS = [
  { key: "routes", label: "Moje závozy", icon: Truck },
];

function DriverPage() {
  const { userRole } = useAuth();
  const [activeSection, setActiveSection] = useState("routes");

  const panelTitle = userRole === "DRIVER" ? "VODIČ PANEL" : "PANEL";

  return (
    <div className="driver">
      <SharedSidebar
        title={panelTitle}
        items={DRIVER_MENU_ITEMS}
        activeKey={activeSection}
        onSelect={setActiveSection}
      />

      <main className="driver__content">
        <DriverRoutesSection />
      </main>
    </div>
  );
}

export default DriverPage;
